import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    console.log(error.response.status);
    if (error.response.status === 401) {
      localStorage.removeItem("access_token");
      location.hash = "#/auth";
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
